"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNavigatorGPC = exports.getNavigatorDoNotTrack = exports.getClientCookieConsent = exports.getCsReplayLink = exports.getBrowserLanguage = exports.getPerimeterxScore = exports.getDateXMinutesFromNow = exports.deepEquals = exports.setCookieOnRootDomain = exports.getLocalPortFromUrl = exports.getLocalPortFromParam = exports.getUserAgent = exports.noWindow = exports.getCommandKey = exports.getNamespaceKey = exports.isObject = exports.wrapTimeout = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constants = require("../constants");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _urls = require("./urls");

var _logger = _interopRequireDefault(require("./logger"));

var _onetrust = require("../utils/onetrust");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var wrapTimeout = function wrapTimeout(cb, time) {
  return new Promise(function (resolve) {
    return setTimeout(function () {
      return resolve(cb());
    }, time);
  });
};

exports.wrapTimeout = wrapTimeout;

var isObject = function isObject(obj) {
  return !!obj && Object.getPrototypeOf(obj) === Object.prototype;
};

exports.isObject = isObject;

var getNamespaceKey = function getNamespaceKey(namespace) {
  return "".concat(namespace, "RswCommand");
};

exports.getNamespaceKey = getNamespaceKey;

var getCommandKey = function getCommandKey(namespace) {
  return namespace ? "".concat(namespace, "RswCommand") : _constants.DEFAULT_COMMAND_KEY;
};

exports.getCommandKey = getCommandKey;

var noWindow = function noWindow() {
  return typeof window === 'undefined';
};

exports.noWindow = noWindow;

var getUserAgent = function getUserAgent(userAgentInput) {
  var userAgent;

  if (userAgentInput) {
    userAgent = userAgentInput;
  } else if (!noWindow()) {
    userAgent = window.navigator.userAgent;
  } else {
    userAgent = 'unknown';
  }

  return userAgent;
};

exports.getUserAgent = getUserAgent;

var getLocalPortFromParam = function getLocalPortFromParam(localPortParam) {
  if (localPortParam === true) {
    return _constants.LOCAL_ENV_DEFAULT_PORT;
  } else if (Number(localPortParam)) {
    return Number(localPortParam);
  }

  return null;
};

exports.getLocalPortFromParam = getLocalPortFromParam;

var getLocalPortFromUrl = function getLocalPortFromUrl(locationParam) {
  if (noWindow()) {
    return null;
  }

  var location = locationParam ? locationParam : window.location;

  try {
    if (location.href.includes(_constants.LOCAL_ENV_QUERY_PARAM)) {
      var queryParams = new URLSearchParams(location.search);
      var localPort = queryParams.get(_constants.LOCAL_ENV_QUERY_PARAM);

      if (Number(localPort)) {
        return Number(localPort);
      } else if (localPort === 'true') {
        return _constants.LOCAL_ENV_DEFAULT_PORT;
      }
    }
  } catch (e) {
    return null;
  }

  return null;
};

exports.getLocalPortFromUrl = getLocalPortFromUrl;

var setCookieOnRootDomain = function setCookieOnRootDomain(cookieName, cookieValue, jsCookieParams) {
  if ((0, _onetrust.consentGrantedSNC)()) {
    try {
      var domain = (0, _urls.isLocalDomain)(window.location.href) ? undefined : (0, _urls.getRootDomain)(window.location.href);

      var params = _objectSpread({
        domain: domain,
        secure: true,
        SameSite: 'None'
      }, jsCookieParams);

      _jsCookie["default"].set(cookieName, cookieValue, params);
    } catch (e) {
      _logger["default"].error(e);
    }
  }
};

exports.setCookieOnRootDomain = setCookieOnRootDomain;

var deepEquals = function deepEquals(val1, val2) {
  if (val1 === val2) {
    return true;
  } else if (isObject(val1)) {
    if (!isObject(val2)) {
      return false;
    } else {
      var obj1Entries = Object.entries(val1);

      if (obj1Entries.length !== Object.keys(val2).length) {
        return false;
      }

      return obj1Entries.reduce(function (isEqual, _ref) {
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
            key = _ref2[0],
            v1 = _ref2[1];

        if (isEqual === false) {
          return isEqual;
        }

        var v2 = val2[key];
        return deepEquals(v1, v2);
      }, true);
    }
  } else if (Array.isArray(val1)) {
    if (!Array.isArray(val2) || val1.length !== val2.length) {
      return false;
    } else {
      var val2Sorted = val2.sort(function (x, y) {
        return x < y ? -1 : 1;
      }); // Return false if any index is unequal:

      return !val1.sort(function (x, y) {
        return x < y ? -1 : 1;
      }).some(function (v1, i) {
        var v2 = val2Sorted[i];
        return deepEquals(v1, v2) === false;
      });
    }
  } else {
    return false;
  }
};

exports.deepEquals = deepEquals;

var getDateXMinutesFromNow = function getDateXMinutesFromNow(minutes) {
  return new Date(Date.now() + 60000 * minutes);
};

exports.getDateXMinutesFromNow = getDateXMinutesFromNow;

var getPerimeterxScore = function getPerimeterxScore() {
  var _window$digitalData;

  var perimeterxScore = undefined;

  if (!noWindow() && ((_window$digitalData = window.digitalData) === null || _window$digitalData === void 0 ? void 0 : _window$digitalData.perimeterxScore) !== undefined) {
    var _window$digitalData2;

    perimeterxScore = (_window$digitalData2 = window.digitalData) === null || _window$digitalData2 === void 0 ? void 0 : _window$digitalData2.perimeterxScore;
  }

  return perimeterxScore;
};

exports.getPerimeterxScore = getPerimeterxScore;

var getBrowserLanguage = function getBrowserLanguage() {
  if (!noWindow()) {
    return window.navigator.language;
  } else {
    return '';
  }
};

exports.getBrowserLanguage = getBrowserLanguage;

var getCsReplayLink = function getCsReplayLink() {
  if (!noWindow() && window.csReplayLink) {
    return window.csReplayLink;
  } else {
    return '';
  }
};

exports.getCsReplayLink = getCsReplayLink;

var getClientCookieConsent = function getClientCookieConsent() {
  if (!noWindow()) {
    return window.OnetrustActiveGroups;
  } else {
    return '';
  }
};

exports.getClientCookieConsent = getClientCookieConsent;

var checkForDoNotTrackAndGpcType = function checkForDoNotTrackAndGpcType(val) {
  if (val !== null && val !== undefined) {
    if (val === true || val === 1 || val === 'true' || val === '1') {
      return '1';
    } else if (val === false || val === 0 || val === 'false' || val === '0') {
      return '0';
    } else {
      return 'unspecified';
    }
  } else {
    return null;
  }
};

var getNavigatorDoNotTrack = function getNavigatorDoNotTrack() {
  if (!noWindow()) {
    return checkForDoNotTrackAndGpcType(window.navigator.doNotTrack);
  } else {
    return null;
  }
};

exports.getNavigatorDoNotTrack = getNavigatorDoNotTrack;

var getNavigatorGPC = function getNavigatorGPC() {
  if (!noWindow() && Object.prototype.hasOwnProperty.call(Navigator.prototype, 'globalPrivacyControl')) {
    var TSNavigator = window.navigator;
    return checkForDoNotTrackAndGpcType(TSNavigator.globalPrivacyControl);
  } else {
    return null;
  }
};

exports.getNavigatorGPC = getNavigatorGPC;